import * as React from 'react';
export const boletoSvg = React.forwardRef(function boletoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 0h45v16H0z',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fill: '#000',
          fillRule: 'nonzero',
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M0 15V1h22v14H0ZM20.6 2.4H1.4v11.2h19.2V2.4ZM5.8 4v8h-3V4h3Zm3 0v8H6.6V4h2.2Zm4 0v8h-3V4h3Zm1.8 0v8H14V4h.6Zm2.2 0v8h-1.4V4h1.4ZM19 4v8h-1.4V4H19Z',
        }),
      ),
    ),
  );
});
boletoSvg.defaultProps = {
  width: '22',
  height: '16',
  viewBox: '0 0 22 16',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var boleto = {
  category: 'paymentmethod',
  colorable: true,
  name: 'boleto',
  svg: boletoSvg,
};
